<div class="modal-header">
  <h4 class="modal-title" id="modal-title">{{ data.title }}</h4>
  <button type="button" class="btn-close" aria-label="Close button" aria-describedby="modal-title"
    (click)="modal.dismiss('Cross click')"></button>
</div>
<div class="modal-body">

  <div class="break" [innerHtml]="data.body"></div>


</div>
<div class="modal-footer">
  <button type="button" class="btn btn-outline-secondary" (click)="modal.dismiss(false)">{{ data.cancelBtnText ??
    defaultText.cancelBtnText }}</button>
  <button type="button" ngbAutofocus class="btn btn-danger" (click)="modal.close(true)">{{ data.confirmBtnText ??
    defaultText.confirmBtnText}}</button>
</div>